<template>
  <section class="section-header">
    <div class="container">
      <div class="row">
        <div class="col">
          <div class="breadcrumbs">
            <router-link to="/">{{ $t('general.home') }}</router-link> /
            <slot name="breadcrumbs" />
          </div>

          <h1 v-if="!!$slots.default" class="page-title"><slot /></h1>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SectionHeader',
};
</script>

<style lang="scss" scoped>
  .section-header {
    padding-top: 7rem;
    padding-bottom: 2rem;
    background: rgb(0,0,0);
    background: linear-gradient(0deg, rgba(17,17,17,1) 0%, rgba(51,51,51,1) 100%);
    background-size: cover;
    color: $white;

    .light & {
      color: $base-color;
      background: $white-fade;
    }

    @include media ("<=tablet") {
      padding-top: 5rem;
      padding-bottom: 1.5rem;
    }

    .page-title {
      margin-top: 1rem;
      font-size: 2.125rem;

      @include media ("<=tablet") {
        font-size: 1.25rem;
      }
    }
  }

  .breadcrumbs {
    text-transform: uppercase;
    font-size: 0.75rem;
    opacity: 0.75;

    a {
      color: $color-primary;
    }
  }
</style>
